import { render, staticRenderFns } from "./BeanPrice.vue?vue&type=template&id=552749a4"
import script from "./BeanPrice.vue?vue&type=script&lang=js"
export * from "./BeanPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports